import { create } from 'zustand';
import { policiesService } from './policiesService';
import type { Policy, PolicyCreateRequest } from './types';

interface PoliciesState {
  policies: Policy[];
  loading: boolean;
  error: string | null;

  fetchPolicies: () => Promise<void>;
  createPolicy: (data: PolicyCreateRequest) => Promise<Policy>;
}

export const usePoliciesStore = create<PoliciesState>((set) => ({
  policies: [],
  loading: false,
  error: null,

  fetchPolicies: async () => {
    set({ loading: true, error: null });
    try {
      const data = await policiesService.getPolicies();
      set({ policies: data.results, loading: false });
    } catch {
      set({ error: 'Failed to load policies', loading: false });
    }
  },

  createPolicy: async (data) => {
    const policy = await policiesService.createPolicy(data);
    set((state) => ({ policies: [policy, ...state.policies] }));
    return policy;
  },
}));
